// Видимость non-blocking PUT /counterparty в registration flow.
//
// updateCounterparty в verifyCode сохраняет first_name/last_name/email/phone_2,
// но обёрнут в try/catch и сознательно не блокирует createOrder + редирект
// на YooKassa (см. agent/forms-and-state.md, строка 133): потеря оплаты
// из-за побочного PUT недопустима. Раньше ошибка тонула в console.warn —
// в БД counterparty оставался без имени, в ЛК /account юзер видел
// «не указано» без объяснения причины.
//
// Этот модуль — общий слой над sessionStorage:
//  - registration.js пишет причину при catch (recordProfileSyncFailure),
//    либо чистит при успехе (clearProfileSyncFailure);
//  - account.js на /account читает и рендерит неблокирующий баннер.
//
// sessionStorage переживает редирект на YooKassa и возврат на /account,
// при этом не утекает между вкладками и не остаётся «на завтра» после
// закрытия браузера. localStorage был бы избыточен — после успешной
// регистрации юзеру баннер уже не нужен.

const STORAGE_KEY = 'forum-industry.profile-sync-failed';

/**
 * Прочитать текущую запись о неудачной синхронизации профиля.
 * Возвращает `{ reason, ts }` или `null`.
 */
export function readProfileSyncFailure() {
  if (typeof sessionStorage === 'undefined') return null;
  let raw;
  try {
    raw = sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    if (typeof parsed.reason !== 'string' || !parsed.reason) return null;
    const ts = typeof parsed.ts === 'number' ? parsed.ts : null;
    return { reason: parsed.reason, ts };
  } catch {
    return null;
  }
}

/**
 * Записать причину неудачной синхронизации профиля.
 * Перетирает предыдущую запись — храним только последнюю попытку.
 */
export function recordProfileSyncFailure(reason) {
  if (typeof sessionStorage === 'undefined') return;
  if (typeof reason !== 'string' || !reason) return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ reason, ts: Date.now() })
    );
  } catch {
    // приватный режим / квота исчерпана — баннер не покажем, не критично
  }
}

/**
 * Снять запись (после успешного PUT или клика «закрыть» в баннере).
 */
export function clearProfileSyncFailure() {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {}
}
